import storageService from '@src/services/storage-service';
import type { CommentSortOrder } from '@src/store/contentEntities/model';

const STORAGE_KEY = 'commentSortPreferences';

function loadPreferencesFromStorage(): Record<string, CommentSortOrder> {
    const stored = storageService.localStorage.get(STORAGE_KEY);
    if (!stored) return {};
    try {
        return JSON.parse(stored) as Record<string, CommentSortOrder>;
    } catch {
        return {};
    }
}

function savePreferencesToStorage(preferences: Record<string, CommentSortOrder>): void {
    storageService.localStorage.set(STORAGE_KEY, JSON.stringify(preferences));
}

export function setCommentSortPreference(tokenName: string, sortOrder: CommentSortOrder): void {
    const preferences = loadPreferencesFromStorage();
    preferences[tokenName] = sortOrder;
    savePreferencesToStorage(preferences);
}

export function getCommentSortPreference(tokenName: string): CommentSortOrder | undefined {
    const preferences = loadPreferencesFromStorage();
    return preferences[tokenName];
}

export function clearCommentSortPreference(tokenName: string): void {
    const preferences = loadPreferencesFromStorage();
    delete preferences[tokenName];
    savePreferencesToStorage(preferences);
}
